import { InfoOutline } from "../Icons";
import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Container, IconWrap, Text } from "./styles";










export const Hint = ({
  className,
  text,
  iconColor,
  textColor,
  backgroundColor,
  isFullWidth }) =>
{
  const theme = useContext(ThemeContext);

  return /*#__PURE__*/(
    React.createElement(Container, {
      className: className,
      backgroundColor: backgroundColor,
      isFullWidth: isFullWidth }, /*#__PURE__*/

    React.createElement(IconWrap, null, /*#__PURE__*/
    React.createElement(InfoOutline, { color: iconColor !== null && iconColor !== void 0 ? iconColor : theme.colors['Level 5'] })), /*#__PURE__*/

    React.createElement(Text, { color: textColor }, text)));


};